import { WORKSPACE_HEADER_NAME } from "@sg-protect/core";
import { client, queryOptions } from "../client.ts";

export function tenantInfoQueryOptions() {
    return queryOptions("get", "/bff/tenant/getInfo");
}

export async function fetchTenants(workspaceId?: string) {
    const { data, error } = await client.GET("/bff/tenants", {
        headers: workspaceId ? { [WORKSPACE_HEADER_NAME]: workspaceId } : undefined
    });

    if (error) {
        throw error;
    }

    return data;
}
